import script from "./AuthManagement.vue?vue&type=script&setup=true&lang=js"
export * from "./AuthManagement.vue?vue&type=script&setup=true&lang=js"

import "./AuthManagement.vue?vue&type=style&index=0&id=708d54f6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-708d54f6"]])

export default __exports__